
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';

import { CustomPreferencesResponse } from '../entities/user-preferences-v2/custom-preferences-response';
import { CustomPreferencesUpdateRequest } from '../entities/user-preferences-v2/custom-preferences-update-request';
import { PreferenceDataResponse } from '../entities/user-preferences-v2/preference-data-response';

import { GlobalPreferencesResponse } from '../entities/user-preferences-v2/global-preferences-response';
import { GlobalPreferencesUpdateRequest } from  '../entities/user-preferences-v2/global-preferences-update-request';
import { axiosInstance } from "../axios-instance";

class UserPreferences {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  getCustomUserPreferences(
    preferences?: string,
  ): Promise<AxiosResponse<CustomPreferencesResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<CustomPreferencesResponse>(`${this.baseUrl}/customUserPreferences/namespace/denver`, {
      params: { privacyLevel: 'private', preferences }, 
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });
  }

  modifyCustomUserPreferences(
    userPreferences: CustomPreferencesUpdateRequest,
  ): Promise<AxiosResponse<CustomPreferencesResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.patch<CustomPreferencesResponse>(`${this.baseUrl}/customUserPreferences/namespace/denver`, userPreferences, {
      params: { privacyLevel: 'private' },
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/merge-patch+json',
      },
    });
  }

  getGlobalPreferences(): Promise<AxiosResponse<PreferenceDataResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<PreferenceDataResponse>(`${this.baseUrl}/globalPreferences`, { 
      params: { countryCode: 'US' }, 
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });   
  }

  getGlobalUserPreferences(): Promise<AxiosResponse<GlobalPreferencesResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<GlobalPreferencesResponse>(`${this.baseUrl}/globalPreferences/user`, { 
      params: { countryCode: 'US' }, 
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });   
  }

  setGlobalUserPreferences( 
    globalPreferences: GlobalPreferencesUpdateRequest
  ): Promise<AxiosResponse<GlobalPreferencesResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<GlobalPreferencesResponse>(`${this.baseUrl}/globalPreferences/user`, globalPreferences, { 
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });  
  }
}

export default UserPreferences;
